import React from 'react';
import {Box} from '~/CreateFabricInvitation/components/Box/Box';
import {EditorGroup} from '~/CreateFabricInvitation/components/EditorGroup/EditorGroup';
import {EditorResetHeader} from '~/CreateFabricInvitation/components/EditorHeader/EditorResetHeader';
import {EditBox} from '~/common/FabricInvitation/EventCreateDesign/components/EditBox/EditBox';
import {EditorIcons} from '~/common/FabricInvitation/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useEnvelope} from '~/common/FabricInvitation/EventCreateDesign/components/Envelope/actions/useEnvelope';
import {useLiners} from '~/common/FabricInvitation/EventCreateDesign/components/Envelope/actions/useLiner';
import {useStamp} from '~/common/FabricInvitation/EventCreateDesign/components/Stamp/actions/useStamp';
import {useStickers} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/components/Stickers/actions/useStickers';
import {Stickers} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/components/Stickers/Stickers';
import {useEnvelopeContext} from '~/common/FabricInvitation/EventCreateDesign/contexts/EnvelopeContext';

export const EnvelopeEditor: React.FC = () => {
  const {handleFlipEnvelope} = useEnvelopeContext();
  const {envelopeIcons, onEnvelopeChange, onEnvelopeReset, selectedEnvelope, hasEnvelopeChanged} =
    useEnvelope();
  const {linerIcons, onLinerChange, onLinerReset, selectedLiner, hasLinerChanged} = useLiners();
  const {stampIcons, onStampChange, onStampReset, selectedStamp, hasStampChanged} = useStamp();
  const {hasStickersChanged, onStickersReset} = useStickers();

  return (
    <div className="envelope-editor">
      <EditBox className="envelope-editor__content">
        <EditorGroup>
          <EditorResetHeader
            title="Envelope Colors"
            onReset={onEnvelopeReset}
            dataQaId="step1-envelope-colors-reset"
            enabled={!!hasEnvelopeChanged}
          />
          <Box className="envelope-editor__box" height="7.5rem">
            <EditorIcons
              icons={envelopeIcons}
              onClick={onEnvelopeChange}
              selectedIcon={selectedEnvelope?.icon}
              height={40}
              width={40}
              className="editor-icons__envelope"
              flipEnvelope={handleFlipEnvelope}
              showEnvelopeFront={false}
              circle
            />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorResetHeader
            title="Liners"
            onReset={onLinerReset}
            dataQaId="step1-envelope-liners-reset"
            enabled={!!hasLinerChanged}
          />
          <Box className="envelope-editor__box" height="7.5rem" padding={8}>
            <EditorIcons
              icons={linerIcons}
              onClick={onLinerChange}
              selectedIcon={selectedLiner?.icon}
              className="editor-icons__liner"
              height={40}
              width={54}
              flipEnvelope={handleFlipEnvelope}
              showEnvelopeFront={false}
            />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorResetHeader
            title="Stamps"
            onReset={onStampReset}
            dataQaId="step1-envelope-stamps-reset"
            enabled={!!hasStampChanged}
          />
          <Box className="stamp-editor__box" height="7.5rem" padding={8}>
            <EditorIcons
              icons={stampIcons}
              onClick={onStampChange}
              selectedIcon={selectedStamp?.image}
              height={40}
              width={54}
              className="editor-icons__stamp"
              flipEnvelope={handleFlipEnvelope}
              showEnvelopeFront
            />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorResetHeader
            title="Stickers"
            onReset={onStickersReset}
            dataQaId="step1-envelope-stickers-reset"
            enabled={hasStickersChanged}
          />
          <Box className="sticker-editor__box" height="4rem">
            <Stickers flipEnvelope={handleFlipEnvelope} />
          </Box>
        </EditorGroup>
      </EditBox>
    </div>
  );
};
